module.exports = __webpack_public_path__ + "img/ocean-room.0303e558.jpg";